export default "__VITE_ASSET__Cppe6sK$__"